import { createTheme as g } from "./ghl-ui.es855.js";
import s from "./ghl-ui.es1157.js";
import u from "./ghl-ui.es1029.js";
import S from "./ghl-ui.es903.js";
const L = (o) => {
  const {
    fontSize: r,
    boxShadow2: t,
    popoverColor: e,
    textColor2: i,
    borderRadius: m,
    borderColor: n,
    heightSmall: l,
    heightMedium: h,
    heightLarge: c,
    fontSizeSmall: a,
    fontSizeMedium: d,
    fontSizeLarge: p,
    dividerColor: f
  } = o;
  return {
    panelFontSize: r,
    boxShadow: t,
    color: e,
    textColor: i,
    borderRadius: m,
    border: `1px solid ${n}`,
    heightSmall: l,
    heightMedium: h,
    heightLarge: c,
    fontSizeSmall: a,
    fontSizeMedium: d,
    fontSizeLarge: p,
    dividerColor: f
  };
}, b = g({
  name: "ColorPicker",
  common: s,
  peers: {
    Input: u,
    Button: S
  },
  self: L
}), P = b;
export {
  P as default,
  L as self
};
